import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { Close, Check } from "@element-plus/icons-vue";
import { computed, reactive, watch } from "vue";
export default {
  props: ["questionInfo", "allAnswers"],
  setup(props, content) {
    //处理题目
    let itemText = computed(() => {
      let text = props.questionInfo.itemText;
      return text;
    });
    //答案
    let answer = reactive({});
    watch(props, () => {
      let list = {};
      props.questionInfo.questionGroupList.forEach(questionGroup => {
        questionGroup.questionList.forEach(questionItem => {
          if (questionGroup.questionMethod == "mcq" || questionGroup.questionMethod == "judge") {
            list[questionItem.questionId] = props.allAnswers && props.allAnswers[questionItem.questionId] ? props.allAnswers[questionItem.questionId] : "";
          } else if (questionGroup.questionMethod == "mmcq") {
            list[questionItem.questionId] = props.allAnswers && props.allAnswers[questionItem.questionId] ? props.allAnswers[questionItem.questionId].split(",") : [];
          }
        });
      });
      Object.assign(answer, list);
      setAnswer();
    }, {
      immediate: true
    });
    //更换题目
    watch(() => props.questionInfo, () => {
      document.getElementsByClassName("question-text")[0].scrollTop = 0;
      document.getElementsByClassName("answer")[0].scrollTop = 0;
    });
    function setAnswer() {
      let data = {};
      for (let key in answer) {
        if (answer[key] instanceof Array) {
          data[key] = answer[key].join(",");
        } else {
          data[key] = answer[key];
        }
      }
      content.emit("setAnswer", data);
    }
    return {
      itemText,
      answer,
      setAnswer,
      Close,
      Check
    };
  }
};